"use client"

import Link from "next/link"

import { useAnalyticsContext } from "@/components/analytics-provider"
import { Button, ButtonProps } from "@/components/ui/button"
import { Translate } from "@/components/ui/translate"
import { H3, P } from "@/components/ui/typography"
import { AnalyticsActionPayload } from "@/store/analytics-store"
import { ComponentProps } from "react"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type FillMethodProps = {
  title: string
  body: string
  href: ComponentProps<typeof Link>["href"]
  analyticsPayload?: AnalyticsActionPayload
  qa?: string
  ctaLabel: string
  ctaVariant: ButtonProps["variant"]
}

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const FillMethod = ({
  title,
  body,
  href,
  analyticsPayload,
  qa,
  ctaLabel,
  ctaVariant,
}: FillMethodProps) => {
  const { sendData } = useAnalyticsContext()

  const handleClick = () => {
    if (analyticsPayload) sendData(analyticsPayload)
  }

  return (
    <Link href={href} onClick={handleClick} data-qa={qa}>
      <div className="bg-paper rounded-card flex flex-col justify-between gap-4 border-1 border-black p-4">
        <div className="flex flex-col gap-2">
          <H3
            className="font-secondary text-title-s text-header-text font-extrabold"
            i18nKey={title}
          />
          <P className="text-paragraph-m text-header-text" i18nKey={body} />
        </div>

        <Button variant={ctaVariant} className="ml-auto">
          <Translate i18nKey={ctaLabel} />
        </Button>
      </div>
    </Link>
  )
}

export { FillMethod }
